<template>
<w-map-popup title="오브젝트 속성" class="object-property">
  <div v-show="selectedObjectLength < 1" :class="$style['no-data']">
    오브젝트를 선택해주십시오.
  </div>
  <el-scrollbar ref="elScrollbar">
    <div v-show="selectedObjectLength > 0" :class="['page-container-left-col', $style['div-wrapper']]">
      <el-collapse ref="collapse">
        <el-collapse-item v-for="(item, index) in propertyItems" :key="index" :name="item.model.name" v-show="item.objects.length > 0" :title="`${item.title} (${item.objects.length})`">
          <ul class="list-drag">
            <component :is="item.component" :objects="item.objects"></component>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </el-scrollbar>
</w-map-popup>
</template>

<script>
import { isEmpty } from '@/utils/basic';

import MapConst from '@/constants/topologymap';

import { Q, MapInfo } from '@/views/topologymap/js/maps';

import WMapPopup from '@/views/topologymap/components/MapPopup';
import WManagedObjectProperty from '@/views/topologymap/components/property/ManagedObjectProperty';
import WLineProperty from '@/views/topologymap/components/property/LineProperty';
import WVirtualObjectProperty from '@/views/topologymap/components/property/VirtualObjectProperty';
import WVirtualLanProperty from '@/views/topologymap/components/property/VirtualLanProperty';
import WSubTopologymapProperty from '@/views/topologymap/components/property/SubTopologymapProperty';
import WShapeProperty from '@/views/topologymap/components/property/ShapeProperty';
import WImageProperty from '@/views/topologymap/components/property/CustomImageProperty';
import WLabelProperty from '@/views/topologymap/components/property/LabelProperty';
import WCustom1Model from '@/views/topologymap/components/property/CustomObjectProperty';

export default {
  name: 'WObjectPropertyWindow',
  components: {
    WMapPopup,
    WManagedObjectProperty,
    WLineProperty,
    WVirtualObjectProperty,
    WVirtualLanProperty,
    WSubTopologymapProperty,
    WShapeProperty,
    WImageProperty,
    WLabelProperty,
    WCustom1Model,
  },
  data() {
    return {
      /**
       * 팝업 속성
       * @type {Object}
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        x: window.innerWidth - 520,
        y: 220,
        width: 503,
        height: 400,
        minWidth: 503,
        minHeight: 400,
        clickToClose: false,
        draggable: '.popup-header',
        resizable: false,
      },
      events: {
        shown(evt) {
          evt.popup.setObjects();
        },
      },
      /**
       * 속성 타입 목록
       * @type {Array}
       */
      propertyItems: [
        {
          model: Q.ManagedObjectModel,
          title: '관리 대상',
          component: WManagedObjectProperty,
          objects: [],
        },
        {
          model: Q.VirtualObjectModel,
          title: '가상 객체',
          component: WVirtualObjectProperty,
          objects: [],
        },
        {
          model: Q.ImageModel,
          title: '사용자 이미지',
          component: WImageProperty,
          objects: [],
        },
        {
          model: Q.ShapeModel,
          title: '도형',
          component: WShapeProperty,
          objects: [],
        },
        {
          model: Q.LabelModel,
          title: '텍스트',
          component: WLabelProperty,
          objects: [],
        },
        {
          model: Q.VirtualLanModel,
          title: '가상랜',
          component: WVirtualLanProperty,
          objects: [],
        },
        {
          model: Q.SubTopologymapModel,
          title: '하위맵',
          component: WSubTopologymapProperty,
          objects: [],
        },
        {
          model: Q.Custom1Model,
          title: '사용자 정의 위젯',
          component: WCustom1Model,
          objects: [],
        },
        {
          model: Q.LanModel,
          title: '선',
          component: WLineProperty,
          objects: [],
        },
      ],
      selectedObjectLength: 0,
    };
  },
  created() {
    this.initSelectionChangeInteraction();
  },
  mounted() {
    this.setObjects();
  },
  methods: {
    /**
     * 오브젝트 선택 이벤트를 감지하도록 설정한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    initSelectionChangeInteraction() {
      const graph = MapInfo.getInstance(this).getGraph();

      if (graph) {
        const customInteraction = {
          enddrag: () => this.setObjects(),
          enddrag2: () => this.setObjects(),
          onstart: () => this.setObjects(),
          onstart2: () => this.setObjects(),
          onkeydown: (evt) => {
            if (evt.keyCode === 27 || (evt.keyCode === 65 && Q.isMetaKey(evt))) {
              this.setObjects();
            }
          },
        };
        graph.addCustomInteraction(customInteraction);
      }
    },
    /**
     * 선택 된 오브젝트를 컴포넌트에 설정한다.
     * @author KangBonghun(toto1323)
     */
    setObjects() {
      const graph = MapInfo.getInstance(this).getGraph();
      const selectionModel = graph.selectionModel.toDatas();

      this.selectedObjectLength = selectionModel.length;

      let active = '';
      this.propertyItems.forEach((item) => {
        item.objects = selectionModel.filter((model) => model instanceof item.model);

        if (isEmpty(active) && !isEmpty(item.objects)) {
          active = item.model.name;
        }
      });

      this.$nextTick(() => {
        this.$refs.collapse.setActiveNames(active);
      });
    },
  },
};
</script>

<style module>
.no-data {
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 13px;
  color: #434d6b;
  font-weight: 500;
}
.div-wrapper {
  position: inherit !important;
  width: 100% !important;
  border-top: 1px solid #d9d9d9;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/edit/ObjectPropertyWindow.vue